import React from 'react';
import { Typography } from '@mui/material';

export default function TermsOfUse() {
  return (
    <React.Fragment>
      <Typography variant="h3">Remap Terms of Use</Typography>
      <section>
        <Typography variant="body1" gutterBottom={true}>
          These Remap Terms and Conditions of Use (these “Terms and Conditions“)
          set forth the terms and conditions for the use of any and all products
          and services (collectively, the “Services”) provided by Remap
          developers (Yoichiro Tanaka and Masahiko Adachi) to users of the
          Services (the “User“ or “Users“, depending upon the context).
        </Typography>
      </section>
      <section>
        <Typography variant="h4">1. Definitions</Typography>
        <Typography variant="body1" gutterBottom={true}>
          The following words and terms shall have the meanings set forth below
          when they are used in these Terms and Conditions.
        </Typography>
        <Typography variant="body1" gutterBottom={true}>
          1.1 “Contents” means information such as text, sounds, music, images,
          videos, software, programs, computer code, and other information.
        </Typography>
        <Typography variant="body1" gutterBottom={true}>
          1.2 “Subject Contents” means Contents that may be accessed through the
          Services.
        </Typography>
        <Typography variant="body1" gutterBottom={true}>
          1.3 “Submitted Contents” means Contents that Users have submitted,
          transmitted or uploaded on or to the Services.
        </Typography>
        <Typography variant="body1" gutterBottom={true}>
          1.4 “Separate Terms and Conditions” means terms and conditions
          separate from these Terms and Conditions that pertain to the Services
          released or uploaded by Remap developers under names such as “terms,”
          “guidelines,” “policies,” or the like.
        </Typography>
        <Typography variant="body1" gutterBottom={true}>
          1.5 “Organization” means some group including a corporation, a
          voluntary association, a community and etc. An organization can become
          a publisher of keyboards in Remap.
        </Typography>
      </section>
      <section>
        <Typography variant="h4">
          2. Agreement to these Terms and Conditions
        </Typography>
        <Typography variant="body1" gutterBottom={true}>
          2.1 All Users shall use the Services in accordance with these Terms
          and Conditions. Users may not use the Services unless they agree to
          these Terms and Conditions.
        </Typography>
        <Typography variant="body1" gutterBottom={true}>
          2.2 If there are Separate Terms and Conditions applicable to the
          Services, Users shall also comply with such Separate Terms and
          Conditions as well as these Terms and Conditions in using the
          Services.
        </Typography>
      </section>
      <section>
        <Typography variant="h4">
          3. Modification to these Terms and Conditions
        </Typography>
        <Typography variant="body1" gutterBottom={true}>
          Remap developers may modify these Terms and Conditions when Remap
          developers deems it to be necessary, within the scope of the purposes
          of the Services. In such case, Remap developers will indicate the
          contents of the modified version of these Terms and Conditions, as
          well as the effective date of the modification, on the Services or on
          Remap’s website, or will publicize the same to Users by notifying
          Users in the manner prescribed by Remap developers.
        </Typography>
        <Typography variant="body1" gutterBottom={true}>
          The modified version of these Terms and Conditions shall become
          effective as of the effective date thereof.
        </Typography>
      </section>
      <section>
        <Typography variant="h4">4. Account</Typography>
        <Typography variant="body1" gutterBottom={true}>
          4.1 When using the Services, Users may need to set up an account by
          registering certain information. Users must register true, accurate
          and complete information, and must revise the same to keep such
          information up-to-date at all times.
        </Typography>
        <Typography variant="body1" gutterBottom={true}>
          4.2 If Users register any authentication information when using the
          Services, they must exercise due care in handling such information at
          their own responsibility to ensure that such information is not used
          in an unlawful manner. Remap developers may treat any and all
          activities conducted under the authentication information as
          activities that have been conducted by the User with whom the
          authentication information is registered.
        </Typography>
        <Typography variant="body1" gutterBottom={true}>
          4.3 Any User who has registered for the Services may delete such a
          User&apos;s account and cancel the Services at any time.
        </Typography>
        <Typography variant="body1" gutterBottom={true}>
          4.4 Remap developers reserve the right to delete any account that has
          been inactive for a period of one (1) year or more since its last
          activation, without any prior notice to the applicable User.
        </Typography>
        <Typography variant="body1" gutterBottom={true}>
          4.5 Any and all rights of a User to use the Service shall cease to
          exist when such User’s account has been deleted for any reason. Please
          take note that an account cannot be retrieved even if a User has
          accidentally deleted their account.
        </Typography>
        <Typography variant="body1" gutterBottom={true}>
          4.6 Each account in the Services is for exclusive use and belongs
          solely to the User of such account. Users may not transfer, lease or
          otherwise dispose their rights to use the Service to any third party,
          nor may the same be inherited or succeeded by any third party.
        </Typography>
      </section>
      <section>
        <Typography variant="h4">5. Privacy</Typography>
        <Typography variant="body1" gutterBottom={true}>
          5.1 Remap developers place top priority on the privacy of its Users.
        </Typography>
        <Typography variant="body1" gutterBottom={true}>
          5.2 Remap developers will appropriately handle privacy information and
          personal information of Users in accordance.
        </Typography>
        <Typography variant="body1" gutterBottom={true}>
          5.3 Remap developers promise to exercise the utmost care and attention
          to its security measures to ensure the safe management of any and all
          information collected from Users.
        </Typography>
      </section>
      <section>
        <Typography variant="h4">6. Provision of the Service</Typography>
        <Typography variant="body1" gutterBottom={true}>
          6.1 Users shall supply PCs, mobile phone devices, smartphones and
          other communication devices, operating systems, communication methods
          and electricity, etc. necessary for using the Services at their own
          responsibility and expense.
        </Typography>
        <Typography variant="body1" gutterBottom={true}>
          6.2 Remap developers reserve the right to limit access to all or part
          of the Services by Users depending upon conditions that Remap
          developers consider necessary, such as the age and identification of
          User, current registration status, and the like.
        </Typography>
        <Typography variant="body1" gutterBottom={true}>
          6.3 Remap developers reserve the right to modify, at Remap
          developer&apos;s discretion, all or part of the Services as Remap
          developers determine necessary anytime without any prior notice to
          Users.
        </Typography>
        <Typography variant="body1" gutterBottom={true}>
          6.4 Remap developers may cease providing all or part of the Services
          without any prior notice to Users in case of the occurrence of any of
          the following
        </Typography>
        <section>
          <Typography variant="body1" gutterBottom={true}>
            (1) When conducting maintenance or repair of systems;
          </Typography>
          <Typography variant="body1" gutterBottom={true}>
            (2) When the Services cannot be provided due to force majeure such
            as an accident (fire, power outage, etc.), act of God, war, riot,
            labor dispute;
          </Typography>
          <Typography variant="body1" gutterBottom={true}>
            (3) When there is system failure or heavy load on the system;
          </Typography>
          <Typography variant="body1" gutterBottom={true}>
            (4) When securing the safety of Users or third parties, or in the
            case of an emergency for the public welfare; or
          </Typography>
          <Typography variant="body1" gutterBottom={true}>
            (5) When Remap developers reasonably determine it to be necessary,
            other than those set forth in items (1) through (4).
          </Typography>
        </section>
      </section>
      <section>
        <Typography variant="h4">7. Advertisements</Typography>
        <Typography variant="body1" gutterBottom={true}>
          Remap developers reserve the right to post advertisements for Remap
          developers or a third party on the Services.
        </Typography>
      </section>
      <section>
        <Typography variant="h4">8. Third-Party Services</Typography>
        <Typography variant="body1" gutterBottom={true}>
          The Services may contain services or Contents provided by third
          parties other than Remap developers. Such third parties shall bear any
          and all responsibility regarding such services and/or Contents.
          Furthermore, there may be terms or use or other terms and conditions
          provided by such third parties which are applicable to such services
          and Contents.
        </Typography>
      </section>
      <section>
        <Typography variant="h4">9. Contents</Typography>
        <Typography variant="body1" gutterBottom={true}>
          9.1 Remap developers grant Users a non-transferable,
          non-sublicensable, non-exclusive license to use the Subject Contents
          provided by Remap developers, solely for the purpose of using the
          Services.
        </Typography>
        <Typography variant="body1" gutterBottom={true}>
          9.2 Users shall abide by the conditions applicable thereto when using
          the Subject Contents which are subject to conditions of use, such as
          additional fees and periods of use and the like. Even if terms such as
          “Purchase”, “Sales,” and the like appear on the screens for the
          Services, Remap developers shall remain the owner of all intellectual
          property rights as well as all other rights in the Subject Contents
          offered to Users by Remap developers, and such rights shall not be
          transferred to Users. Users will only be granted usage rights as set
          forth above.
        </Typography>
        <Typography variant="body1" gutterBottom={true}>
          9.3 Users shall not use the Subject Contents beyond the scope of the
          intended use of the Subject Contents in the Services (including,
          without limitation, acts of copying, transmitting, reproducing, and
          modifying).
        </Typography>
        <Typography variant="body1" gutterBottom={true}>
          9.4 If Users wish to back-up all or part of the Submitted Contents,
          they will need to do so themselves. Remap developers will not
          undertake the obligation of backing up any of the Submitted Contents.
        </Typography>
        <Typography variant="body1" gutterBottom={true}>
          9.5 The Services may include functions where multiple Users may edit
          Contents (post, correct, and delete, etc.). In such a case, a User who
          posted his/her Submitted Contents shall grant other Users the right to
          edit such Submitted Contents.
        </Typography>
        <Typography variant="body1" gutterBottom={true}>
          9.6 Users shall retain their rights to their Submitted Contents, and
          Remap developers shall not acquire any such rights; provided, however,
          that, among the Submitted Contents, for those made available to other
          Users generally, the User who posted such Submitted Contents shall be
          deemed to have granted Remap developers a worldwide, perpetual,
          royalty-free license (including the right to amend such Contents to
          the extent Remap developers deem necessary and appropriate, and the
          right to sublicense such usage rights to other third parties working
          together with Remap developers), to use such Contents for services
          and/or promotional purposes.
        </Typography>
        <Typography variant="body1" gutterBottom={true}>
          9.7 Users shall not exercise their rights such as author’s moral
          rights with respect to the Submitted Contents in relation to the use
          by Remap developers or a third party under Articles 9.5 and 9.6 above.
        </Typography>
        <Typography variant="body1" gutterBottom={true}>
          9.8 Remap developers may check and confirm the contents of the
          Submitted Contents by Users to the extent permissible under laws and
          regulations, when it is necessary for Remap developers to confirm
          compliance with related laws and regulations or the provisions set out
          in these Terms and Conditions, etc.; provided, however, that Remap
          developers are not obligated to conduct such confirmation.
        </Typography>
        <Typography variant="body1" gutterBottom={true}>
          9.9 If Remap developers believe that a User has violated or may
          violate any applicable laws or regulations or the provisions of these
          Terms and Conditions in relation to the Submitted Contents, or when
          otherwise reasonably necessary for Remap developer&apos;s business,
          then Remap developers reserves the right to preclude such User&apos;s
          use of the Services in certain manners, such as deleting the Submitted
          Contents without providing prior notice to the User.
        </Typography>
      </section>
      <section>
        <Typography variant="h4">10. Restricted Matters</Typography>
        <Typography variant="body1" gutterBottom={true}>
          Remap developers prohibit Users from engaging in any of the following
          acts when using the Services:
        </Typography>
        <Typography variant="body1" gutterBottom={true}>
          10.1 Acts that violate the laws and regulations, court verdicts,
          resolutions or orders, or administrative measures that are legally
          binding;
        </Typography>
        <Typography variant="body1" gutterBottom={true}>
          10.2 Acts that may be in violation of public order, morals or customs;
        </Typography>
        <Typography variant="body1" gutterBottom={true}>
          10.3 Acts that infringe intellectual property rights, such as
          copyrights, trademarks and patent rights, rights to fame, privacy, and
          all other rights granted by law or by a contract with Remap developers
          and/or a third party;
        </Typography>
        <Typography variant="body1" gutterBottom={true}>
          10.4 Acts of posting or transmitting excessively violent or explicit
          sexual expressions; expressions that amount to child pornography or
          child abuse; expressions that lead to discrimination by race, national
          origin, creed, gender, social status, family origin, etc.; expressions
          that induce or encourage suicide, self-injurious behavior or drug
          abuse; or expressions that include anti-social content and lead to the
          discomfort of others;
        </Typography>
        <Typography variant="body1" gutterBottom={true}>
          10.5 Acts that lead to the misrepresentation of Remap developers
          and/or a third party or that intentionally spread false information;
        </Typography>
        <Typography variant="body1" gutterBottom={true}>
          10.6 Acts of sending the same or similar messages to a large,
          indefinite number of Users (except for those approved by Remap
          developers), indiscriminately adding other Users as friends or to
          group chats, or any other acts deemed by Remap developers to
          constitute spamming;
        </Typography>
        <Typography variant="body1" gutterBottom={true}>
          10.7 Acts of exchanging the right to use the Services or Contents into
          cash, property or other economic benefits, other than by using the
          method prescribed by Remap developers;
        </Typography>
        <Typography variant="body1" gutterBottom={true}>
          10.8 Acts of using the Services for sales, marketing, advertising,
          solicitation or other commercial purposes (except for those approved
          by Remap developers); using the Services for the purpose of sexual
          conduct or obscene acts; using the Services for the purpose of meeting
          or engaging in sexual encounters with an unknown third party; using
          the Services for the purpose of harassment or libelous attacks against
          other Users; or otherwise using the Services for purposes other than
          as intended by the Services;
        </Typography>
        <Typography variant="body1" gutterBottom={true}>
          10.9 Acts that benefit or involve collaboration with anti-social
          groups;
        </Typography>
        <Typography variant="body1" gutterBottom={true}>
          10.10 Acts that are related to religious activities or invitations to
          certain religious groups;
        </Typography>
        <Typography variant="body1" gutterBottom={true}>
          10.11 Acts of unauthorized or improper collection, disclosure, or
          provision of any other person&apos;s personal information, registered
          information, user history, or the like;
        </Typography>
        <Typography variant="body1" gutterBottom={true}>
          10.12 Acts of interfering with the servers and/or network systems of
          the Services; fraudulently manipulating the Services by means of bots,
          cheat tools, or other technical measures; deliberately using defects
          of the Services; making unreasonable inquires and/or undue claims such
          as repeatedly asking the same questions beyond what is necessary, and
          other acts of interfering with or hindering Remap developers&apos;
          operation of the Services or other Users’ use of the Services;
        </Typography>
        <Typography variant="body1" gutterBottom={true}>
          10.13 Acts of decoding the source code of the Services, such as by way
          of reverse engineering, disassembling or the like, for unreasonable
          purposes or in an unfair manner;
        </Typography>
        <Typography variant="body1" gutterBottom={true}>
          10.14 Acts that aid or encourage any acts stated in Clauses 10.1 to
          10.13 above; and
        </Typography>
        <Typography variant="body1" gutterBottom={true}>
          10.15 Acts other than those set forth in Clauses 10.1 to 10.14 that
          Remap developers reasonably deems to be inappropriate.
        </Typography>
      </section>
      <section>
        <Typography variant="h4">11. User Responsibility</Typography>
        <Typography variant="body1" gutterBottom={true}>
          11.1 Users shall use the Services at their own risk, and shall bear
          any and all responsibilities for actions carried out under and the
          results from the use of the Services.
        </Typography>
        <Typography variant="body1" gutterBottom={true}>
          11.2 Remap developers may suspend the use of all or part of the
          Services, suspend or delete accounts, cancel any agreement between a
          User and Remap developers with respect to the Services (including,
          without limitation, any agreement based on these Terms and Conditions,
          hereinafter the same) or take any other measure Remap developers
          reasonably determines to be necessary and appropriate without prior
          notice to such User in the case that such User falls under or there is
          a possibility that such User falls under any of the following items:
        </Typography>
        <section>
          <Typography variant="body1" gutterBottom={true}>
            (1) A User is in breach of applicable laws and regulations, these
            Terms and Conditions, or any Separate Terms and Conditions;
          </Typography>
          <Typography variant="body1" gutterBottom={true}>
            (2) A User is a member of an anti-social group or a related party
            thereof;
          </Typography>
          <Typography variant="body1" gutterBottom={true}>
            (3) A User tarnishes Remap developers’s credibility by spreading
            false information, using fraudulent means or force, or other
            unlawful means;
          </Typography>
          <Typography variant="body1" gutterBottom={true}>
            (4)A User is subject to a petition for attachment, provisional
            attachment, or auction, ; procedures such as bankruptcy, civil
            rehabilitation, or similar procedures are commenced; or Remap
            developers otherwise reasonably determines that there is uncertainty
            with respect to User’s credibility; or
          </Typography>
          <Typography variant="body1" gutterBottom={true}>
            (5) The relationship of trust with a User is lost or Remap
            developers otherwise reasonably determine that it would not be
            appropriate for Remap developers to provide the Services to User,
            due to reasons other than as set forth in items (1) to (4) above.
          </Typography>
        </section>
        <Typography variant="body1" gutterBottom={true}>
          11.3 In the case where Remap developers suffers loss/damages either
          directly or indirectly (including, without limitation, attorney fees)
          due to a User’s use of the Services (including, without limitation,
          cases where Remap developers receives a complaint from a third party
          due to such use), the User shall immediately compensate Remap
          developers for such loss/damage in accordance with Remap developers’
          request.
        </Typography>
      </section>
      <section>
        <Typography variant="h4">12. Organizations</Typography>
        <Typography variant="body1" gutterBottom={true}>
          12.1 It is necessary that all organizations registered to the Remap
          must have activities related to keyboards continuously.
        </Typography>
        <Typography variant="body1" gutterBottom={true}>
          12.2 If an organization is a corporation, the corporation has a
          responsibility for the organization. On the other hand, if an
          organization is not a corporation, the contact person has a
          responsibility for the organization.
        </Typography>
        <Typography variant="body1" gutterBottom={true}>
          12.3 Organizations comply with laws, regulations, and these Terms, and
          in the event of any dispute resulting from the use of the Remap, the
          organization must solve the issue at its expense and responsibility
          and must not cause any inconvenience or inconvenience or any damage to
          the Remap team.
        </Typography>
        <Typography variant="body1" gutterBottom={true}>
          12.4 An organization must keep that the Remap team can contact the
          organization anytime using the registered contact information. If the
          contact information is changed, the organization must report it to the
          Remap team and must update it immediately.
        </Typography>
        <Typography variant="body1" gutterBottom={true}>
          12.5 The members of an organization can add other members only who are
          related to the organization and must not add unrelated users as the
          member.
        </Typography>
        <Typography variant="body1" gutterBottom={true}>
          12.6 The Remap team has an ability to restrict and delete
          organizations which act that violate the laws and regulations, court
          verdicts, resolutions or orders, or administrative measures that are
          legally binding, or act that may be in violation of public order,
          morals or customs.
        </Typography>
        <Typography variant="body1" gutterBottom={true}>
          12.7 If the registered information of an organization is incomplete or
          false, or if the organization violates this agreement, or if the Remap
          team determines that there is a risk of these, the Remap team can take
          measures such as deleting it and related information or temporarily
          making the organization unavailable without contacting the
          organization in advance from the Remap team.
        </Typography>
      </section>
      <section>
        <Typography variant="h4">13. NO WARRANTY</Typography>
        <Typography variant="body1" gutterBottom={true}>
          REMAP DEVELOPERS SHALL PROVIDE NO WARRANTY, EITHER EXPRESSLY OR
          IMPLIEDLY, WITH RESPECT TO THE SERVICES (INCLUDING THE SUBJECT
          CONTENTS), THAT THERE ARE NO DEFECTS (INCLUDING, WITHOUT LIMITATION,
          FAULTS WITH RESPECT TO SECURITY, ETC., ERRORS OR BUGS, OR VIOLATIONS
          OF RIGHTS) OR AS TO THE SAFETY, RELIABILITY, ACCURACY, COMPLETENESS,
          EFFECTIVENESS AND FITNESS FOR A PARTICULAR PURPOSE. REMAP DEVELOPERS
          WILL IN NO WAY BE RESPONSIBLE FOR PROVIDING USERS WITH THE SERVICES
          AFTER DELETING SUCH DEFECTS.
        </Typography>
      </section>
      <section>
        <Typography variant="h4">
          14. REMAP DEVELOPERS&apos; LIMITATION OF LIABILITY
        </Typography>
        <Typography variant="body1" gutterBottom={true}>
          14.1 REMAP DEVELOPERS WILL NOT BE LIABLE FOR ANY DAMAGE INCURRED BY
          USERS FROM THE USE OF THE SERVICES, UNLESS SUCH DAMAGE IS ATTRIBUTABLE
          TO THE INTENTIONAL OR GROSSLY NEGLIGENT ACTS OF REMAP DEVELOPERS;
          PROVIDED, HOWEVER, THAT, IN THE CASE THAT THE AGREEMENT BETWEEN THE
          USER AND REMAP DEVELOPERS WITH RESPECT TO THE USE OF THE SERVICES
          FALLS UNDER A CONSUMER CONTRACT AS DEFINED UNDER THE CONSUMER CONTRACT
          ACT OF JAPAN (“CONSUMER CONTRACT”), REMAP DEVELOPERS WILL BE LIABLE TO
          PROVIDE COMPENSATION FOR DAMAGE ARISING DUE TO NEGLIGENCE ON THE PART
          OF REMAP DEVELOPERS (EXCLUDING GROSS NEGLIGENCE) ARISING FROM CONTRACT
          OR TORT ONLY WITHIN THE RANGE OF (A) THE DAMAGE WHICH IS NORMALLY
          INCURRED (I.E., EXCLUSIVE OF LOST PROFITS AND OTHER DAMAGES ARISING
          UNDER SPECIAL CIRCUMSTANCES), AND (B) THE AMOUNT OF USAGE FEES FOR THE
          SERVICES RECEIVED FROM SUCH USER FOR FEE-BASED SERVICES FOR THE MONTH
          IN WHICH SUCH DAMAGE HAS BEEN INCURRED, AT MAXIMUM.
        </Typography>
        <Typography variant="body1" gutterBottom={true}>
          14.2 IF A USER INCURS DAMAGE AS A RESULT OF GROSS NEGLIGENCE ON THE
          PART OF REMAP DEVELOPERS, REMAP DEVELOPERS WILL BE RESPONSIBLE TO
          PROVIDE COMPENSATION FOR THE DAMAGE INCURRED BUT ONLY WITHIN THE RANGE
          OF (A) THE DAMAGE WHICH IS NORMALLY INCURRED (I.E., EXCLUSIVE OF LOST
          PROFITS AND OTHER DAMAGES ARISING UNDER SPECIAL CIRCUMSTANCES), AND
          (B) THE AMOUNT OF USAGE FEES FOR THE SERVICES RECEIVED FROM SUCH USER
          FOR FEE-BASED SERVICES FOR THE MONTH IN WHICH SUCH DAMAGE HAS BEEN
          INCURRED, AT MAXIMUM; PROVIDED, HOWEVER, THAT THE FOREGOING SHALL NOT
          APPLY IF THE AGREEMENT BETWEEN SUCH USER AND REMAP DEVELOPERS FALLS
          UNDER THE DEFINITION OF A CONSUMER CONTRACT.
        </Typography>
      </section>
      <section>
        <Typography variant="h4">
          15. Relationship between these Terms and Conditions and Laws and
          Regulations
        </Typography>
        <Typography variant="body1" gutterBottom={true}>
          If the terms of these Terms and Conditions violate any laws and
          regulations applicable to an agreement between Users and Remap
          developers with respect to the Services (including, without
          limitation, the Consumer Contract Act of Japan), such terms, to the
          extent of such violation, shall not apply to the agreement with the
          Users; provided, however, that the remaining terms of these Terms and
          Conditions shall not be affected.
        </Typography>
      </section>
      <section>
        <Typography variant="h4">16. Notification and Contact</Typography>
        <Typography variant="body1" gutterBottom={true}>
          16.1 For notifications from Remap developers to Users regarding the
          Services, Remap developers will use a method that Remap developers
          considers appropriate, such as posting in an appropriate place within
          the Services or on Remap developers&apos; website.
        </Typography>
        <Typography variant="body1" gutterBottom={true}>
          16.2 For notifications from Users to Remap developers regarding the
          Services, Users shall use the customer inquiry form available on the
          Services or on Remap developers&apos; website, or through other means
          designated by Remap developers.
        </Typography>
      </section>
      <section>
        <Typography variant="h4">17. Governing Law and Jurisdiction</Typography>
        <Typography variant="body1" gutterBottom={true}>
          These Terms and Conditions will be governed by the laws of Japan. Any
          conflicts between Users and Remap developers that arise from or in
          connection with the Service shall be resolved under the exclusive
          jurisdiction of the Tokyo District Court as the court of first
          instance.
        </Typography>
      </section>
      <section>
        <Typography variant="body1" align="right">
          End
        </Typography>
      </section>
      <section>
        <Typography variant="body1" align="right">
          Last updated: January 5th, 2022
          <br />
          Created: January 15th, 2021
        </Typography>
      </section>
    </React.Fragment>
  );
}
